import { NgModule } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconModule} from '@angular/material/icon';
import { MatIconRegistry } from '@angular/material/icon';

@NgModule({
  imports: [
    MatIconModule
  ],
  exports: [
    MatIconModule
  ]
})
export class IconsModule {

private path = './assets/svg/outlined/';

	constructor(
		private domSanitizer: DomSanitizer,
		public matIconRegistry: MatIconRegistry ) {
		this.matIconRegistry
		.addSvgIcon('menu', this.setPath('menu.svg'))
		.addSvgIcon('search', this.setPath('search.svg'))
		.addSvgIcon('notifications', this.setPath('notifications.svg'))
		.addSvgIcon('home', this.setPath('home.svg'))
		.addSvgIcon('inbox', this.setPath('inbox.svg'))
		.addSvgIcon('control_camera', this.setPath('control_camera.svg'))
		.addSvgIcon('work_outline', this.setPath('work_outline.svg'))
		.addSvgIcon('expand_more', this.setPath('expand_more.svg'))
		.addSvgIcon('expand_less', this.setPath('expand_less.svg'))
		.addSvgIcon('chevron_left', this.setPath('chevron_left.svg'))
		.addSvgIcon('chevron_right', this.setPath('chevron_right.svg'))
		.addSvgIcon('add', this.setPath('add.svg'))
		.addSvgIcon('layers', this.setPath('layers.svg'))
		.addSvgIcon('chat_bubble_outline', this.setPath('chat_bubble_outline.svg'))
		.addSvgIcon('info', this.setPath('info.svg'))
		.addSvgIcon('arrow_back', this.setPath('arrow_back.svg'))
		.addSvgIcon('arrow_forward', this.setPath('arrow_forward.svg'))
		.addSvgIcon('arrow_upward', this.setPath('arrow_upward.svg'))
		.addSvgIcon('arrow_downward', this.setPath('arrow_downward.svg'))
		.addSvgIcon('close', this.setPath('close.svg'))
		.addSvgIcon('play_circle_outline', this.setPath('play_circle_outline.svg'))
		.addSvgIcon('play_arrow', this.setPath('play_arrow.svg'))
		.addSvgIcon('radio_button_unchecked', this.setPath('radio_button_unchecked.svg'))
		.addSvgIcon('radio_button_checked', this.setPath('radio_button_checked.svg'))
		.addSvgIcon('language', this.setPath('language.svg'))
		.addSvgIcon('grid_view', this.setPath('grid_view.svg'))
		.addSvgIcon('settings', this.setPath('settings.svg'))
		.addSvgIcon('remove', this.setPath('remove.svg'))
		.addSvgIcon('more_vert', this.setPath('more_vert.svg'))
		.addSvgIcon('person', this.setPath('person.svg'))
		.addSvgIcon('file_download', this.setPath('file_download.svg'))
		.addSvgIcon('schedule', this.setPath('schedule.svg'))
		.addSvgIcon('check_box_outline_blank', this.setPath('check_box_outline_blank.svg'))
		.addSvgIcon('check_box', this.setPath('check_box.svg'))
		.addSvgIcon('swap_vert', this.setPath('swap_vert.svg'))
		.addSvgIcon('delete', this.setPath('delete.svg'))
		.addSvgIcon('edit', this.setPath('edit.svg'))
		.addSvgIcon('visibility', this.setPath('visibility.svg'))
		.addSvgIcon('visibility_off', this.setPath('visibility_off.svg'))
		.addSvgIcon('insert_link', this.setPath('insert_link.svg'))
		.addSvgIcon('place', this.setPath('place.svg'))
		.addSvgIcon('toggle_on', this.setPath('toggle_on.svg'))
		.addSvgIcon('toggle_off', this.setPath('toggle_off.svg'))
		.addSvgIcon('send', this.setPath('send.svg'))
		.addSvgIcon('last_page', this.setPath('last_page.svg'))
		.addSvgIcon('first_page', this.setPath('first_page.svg'))
		.addSvgIcon('open_in_new', this.setPath('open_in_new.svg'))
		.addSvgIcon('light_mode', this.setPath('light_mode.svg'))
		.addSvgIcon('desktop_windows', this.setPath('desktop_windows.svg'))
		.addSvgIcon('show_chart', this.setPath('show_chart.svg'))
		.addSvgIcon('equalizer', this.setPath('equalizer.svg'))
		.addSvgIcon('format_list_bulleted', this.setPath('format_list_bulleted.svg'))
		.addSvgIcon('description', this.setPath('description.svg'))
		.addSvgIcon('grid_view', this.setPath('grid_view.svg'))
		.addSvgIcon('change_circle', this.setPath('change_circle.svg'))
		.addSvgIcon('calendar_today', this.setPath('calendar_today.svg'))
		.addSvgIcon('refresh', this.setPath('refresh.svg'))
		.addSvgIcon('first_page', this.setPath('first_page.svg'))
		.addSvgIcon('last_page', this.setPath('last_page.svg'))
		.addSvgIcon('filter_alt', this.setPath('filter_alt.svg'))
		.addSvgIcon('import_contacts', this.setPath('import_contacts.svg'))
		.addSvgIcon('logout', this.setPath('logout.svg'))
		.addSvgIcon('lock', this.setPath('lock.svg'))
		.addSvgIcon('restart_alt', this.setPath('restart_alt.svg'))
		.addSvgIcon('shield', this.setPath('shield.svg'))
		.addSvgIcon('token', this.setPath('token.svg'))
		.addSvgIcon('error_outline', this.setPath('error_outline.svg'))
		.addSvgIcon('done', this.setPath('done.svg'))
		.addSvgIcon('import_export', this.setPath('import_export.svg'))
		.addSvgIcon('warning_amber', this.setPath('warning_amber.svg'))
		.addSvgIcon('warning', this.setPath('warning.svg'))
		.addSvgIcon('pages', this.setPath('pages.svg'))
		.addSvgIcon('newRelease', this.setPath('new_releases.svg'))
		.addSvgIcon('buildCircle', this.setPath('build_circle.svg'))
		.addSvgIcon('note_alt', this.setPath('note_alt.svg'))
		.addSvgIcon('integration_instructions', this.setPath('integration_instructions.svg'))
		.addSvgIcon('content_copy', this.setPath('content_copy.svg'))
		.addSvgIcon('check', this.setPath('check.svg'))
		.addSvgIcon('integration_instructions', this.setPath('integration_instructions.svg'))
		.addSvgIcon('cancel', this.setPath('cancel.svg'))
		.addSvgIcon('highlight_off', this.setPath('highlight_off.svg'))
		.addSvgIcon('settings_applications', this.setPath('settings_applications.svg'))
		.addSvgIcon('download_for_offline', this.setPath('download_for_offline.svg'))
		.addSvgIcon('inventory_2', this.setPath('inventory_2.svg'))
		.addSvgIcon('donut_large', this.setPath('donut_large.svg'))
		.addSvgIcon('desktop_access_disabled', this.setPath('desktop_access_disabled.svg'));
	}

	private setPath(icon: string): SafeResourceUrl {
		return this.domSanitizer.bypassSecurityTrustResourceUrl(this.path + icon);
	}

}
